module.exports = __webpack_public_path__ + "static/media/lk.d5cf9401.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/lk.svg
// module id = 699
// module chunks = 0